import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Donation from "../views/Donation.vue"
Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home
  },{
    path: '/public/asset/:id',
    name: 'Assets',
    component: () => import(/* webpackChunkName: "about" */ '../views/Asset.vue')
  },
  {
    path: '/mydonation/:id',
    name: 'MyDonation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Mydonation.vue')
  },
  {
    path: "/donation/:company/:refurbisher",
    name: 'Donation',
    component: Donation
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
